import './App.css';
import { useEffect, useState } from 'react';
import SplashCursor from './SplashCursor';
import ProjectLoop from './ProjectLoop';
import vocalexAiAssistant from './assets/projects/vocalex-ai-assistant.png';
import foodDeliveryDark from './assets/projects/food-delivery-dark.png';
import foodDeliveryLight from './assets/projects/food-delivery-light.png';
import saibiPerfume from './assets/projects/saibi-perfume.png';
import vocalexLanding from './assets/projects/vocalex-landing.png';
import capitalCareHospital from './assets/projects/capital-care-hospital.png';
import aboutPortrait from './assets/about/about-portrait.png';
import malikAizazAvatar from './assets/testimonials/malik-aizaz.png';
import abbirKhanLogo from './assets/abbir-khan-logo-transparent.png';

function IconRocket(props) {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" {...props}>
      <path
        d="M13.7 2.2c3.1.2 5.7 2.9 5.9 5.9.1 1.6-.3 3.1-1.2 4.4l-1.9 2.7c-.3.4-.7.6-1.2.6h-4c-.5 0-.9-.2-1.2-.6L8.2 12.5C7.3 11.2 6.9 9.7 7 8.1c.2-3.1 2.8-5.7 5.9-5.9h.8Zm-1.7 16.6h2l-.5 2.1c-.1.6-.7 1-1.3 1s-1.2-.4-1.3-1l-.5-2.1h1.6Zm-4.8-6.1 2.1.7-.8 2.4c-.2.6-.8.9-1.4.8-.6-.2-1-.8-.8-1.4l.9-2.5Zm9.6 0 .9 2.5c.2.6-.2 1.2-.8 1.4-.6.2-1.2-.2-1.4-.8l-.8-2.4 2.1-.7Z"
        fill="currentColor"
        opacity="0.9"
      />
      <path
        d="M12 3.7c-2.5.4-4.4 2.7-4.5 5.3 0 1.1.3 2.1.9 3l1.7 2.4h3.8l1.7-2.4c.6-.9.9-2 .9-3-.1-2.7-2-4.9-4.5-5.3Z"
        fill="currentColor"
      />
      <circle cx="12" cy="9" r="1.4" fill="#050505" opacity="0.85" />
    </svg>
  );
}

function IconSmile(props) {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" {...props}>
      <path
        d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20Zm-3.6-9.1a.9.9 0 0 0-1.7.5c.6 2.3 2.7 4 5.3 4 2.6 0 4.7-1.7 5.3-4a.9.9 0 0 0-1.7-.5c-.4 1.6-1.9 2.7-3.6 2.7-1.7 0-3.2-1.1-3.6-2.7Z"
        fill="currentColor"
      />
      <circle cx="9" cy="10.2" r="1.2" fill="currentColor" opacity="0.95" />
      <circle cx="15" cy="10.2" r="1.2" fill="currentColor" opacity="0.95" />
    </svg>
  );
}

function IconCode(props) {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" {...props}>
      <path
        d="M9.3 16.8a1 1 0 0 1-1.4.1l-4.5-3.8a1.5 1.5 0 0 1 0-2.2l4.5-3.8a1 1 0 1 1 1.3 1.5L5 12l4.4 3.6a1 1 0 0 1 .1 1.2Zm5.4 0a1 1 0 0 0 1.4.1l4.5-3.8a1.5 1.5 0 0 0 0-2.2l-4.5-3.8a1 1 0 0 0-1.3 1.5L19 12l-4.4 3.6a1 1 0 0 0-.1 1.2ZM13.8 6.3a1 1 0 0 0-1.2.7l-3 10.8a1 1 0 1 0 1.9.5l3-10.8a1 1 0 0 0-.7-1.2Z"
        fill="currentColor"
      />
    </svg>
  );
}

function IconCup(props) {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" {...props}>
      <path
        d="M7 3.5h10a1 1 0 0 1 1 1V8h1.2a2.8 2.8 0 0 1 0 5.6H18c-.4 2.9-2.9 5.1-5.9 5.1H12c-3 0-5.5-2.2-5.9-5.1H5a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1h2Zm11 6.1v2.2h1.2a1.1 1.1 0 0 0 0-2.2H18ZM9 20.5h6a1 1 0 0 1 0 2H9a1 1 0 0 1 0-2Z"
        fill="currentColor"
      />
    </svg>
  );
}

function IconMapPin(props) {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" {...props}>
      <path
        d="M12 2.5a7 7 0 0 1 7 7c0 4.8-5.3 10.3-6.6 11.6a.6.6 0 0 1-.8 0C10.3 19.8 5 14.3 5 9.5a7 7 0 0 1 7-7Zm0 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
        fill="currentColor"
      />
    </svg>
  );
}

function IconBolt(props) {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" {...props}>
      <path
        d="M13.1 2.7a.9.9 0 0 1 .8 1.2L12.1 9H18a1 1 0 0 1 .8 1.6l-7.9 10.5a.9.9 0 0 1-1.6-.8L11.1 15H6a1 1 0 0 1-.8-1.6L11.6 3a.9.9 0 0 1 1.5-.3Z"
        fill="currentColor"
      />
    </svg>
  );
}

function IconClock(props) {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" {...props}>
      <path
        d="M12 2.5a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19Zm0 3a1 1 0 0 0-1 1V12c0 .3.1.5.3.7l3.5 3.5a1 1 0 1 0 1.4-1.4L13 11.6V6.5a1 1 0 0 0-1-1Z"
        fill="currentColor"
      />
    </svg>
  );
}

function IconPhone(props) {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" {...props}>
      <path
        d="M6.6 3.5h3a1 1 0 0 1 1 .8l.7 3.2a1 1 0 0 1-.3.9L9.3 10a13 13 0 0 0 4.7 4.7l1.6-1.7a1 1 0 0 1 .9-.3l3.2.7a1 1 0 0 1 .8 1v3a1 1 0 0 1-.8 1A16.8 16.8 0 0 1 5.6 4.3a1 1 0 0 1 1-.8Z"
        fill="currentColor"
      />
    </svg>
  );
}

function IconMail(props) {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" {...props}>
      <path
        d="M4.5 5.5h15a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-15a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2Zm.5 2.1V8l7 5.1a1.7 1.7 0 0 0 2 0L21 8v-.4a.1.1 0 0 0-.1-.1H3.1a.1.1 0 0 0-.1.1Z"
        fill="currentColor"
      />
    </svg>
  );
}

function IconArrowUpRight(props) {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" {...props}>
      <path
        d="M7 17a1 1 0 0 1 0-1.4L15.6 7H10a1 1 0 1 1 0-2h8a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V8.4L8.4 17A1 1 0 0 1 7 17Z"
        fill="currentColor"
      />
    </svg>
  );
}

function IconSend(props) {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" {...props}>
      <path
        d="M20.9 3.7a1.5 1.5 0 0 0-1.6-.3L3.8 9.8a1.4 1.4 0 0 0 .1 2.6l5.8 2 2 5.8a1.4 1.4 0 0 0 1.3.9h.1a1.4 1.4 0 0 0 1.3-.9l6.8-14.9a1.5 1.5 0 0 0-.3-1.6Zm-8 13.4-1.2-3.5 4.5-4.5a1 1 0 0 0-1.4-1.4l-4.5 4.5-3.5-1.2 11.7-4.8-5.6 10.9Z"
        fill="currentColor"
      />
    </svg>
  );
}

function IconFacebook(props) {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" {...props}>
      <path
        d="M14 8.2V6.8c0-.7.4-1.1 1.2-1.1h1.5V3.1c-.7-.1-1.4-.2-2.2-.2-2.4 0-4.1 1.5-4.1 4.2v1.1H7.8V11h2.6v10h3.1V11h2.6l.4-2.8H14Z"
        fill="currentColor"
      />
    </svg>
  );
}

function IconInstagram(props) {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" {...props}>
      <path
        d="M7.4 2.8h9.2a4.6 4.6 0 0 1 4.6 4.6v9.2a4.6 4.6 0 0 1-4.6 4.6H7.4a4.6 4.6 0 0 1-4.6-4.6V7.4a4.6 4.6 0 0 1 4.6-4.6Zm0 2A2.6 2.6 0 0 0 4.8 7.4v9.2a2.6 2.6 0 0 0 2.6 2.6h9.2a2.6 2.6 0 0 0 2.6-2.6V7.4a2.6 2.6 0 0 0-2.6-2.6H7.4Zm4.6 3.1a4.1 4.1 0 1 1 0 8.2 4.1 4.1 0 0 1 0-8.2Zm0 2a2.1 2.1 0 1 0 0 4.2 2.1 2.1 0 0 0 0-4.2Zm4.4-2.7a1.1 1.1 0 1 1 0 2.2 1.1 1.1 0 0 1 0-2.2Z"
        fill="currentColor"
      />
    </svg>
  );
}

function IconLinkedIn(props) {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" {...props}>
      <path
        d="M6.4 8.8H3.5v11.1h2.9V8.8ZM4.9 3.4a1.7 1.7 0 1 0 0 3.4 1.7 1.7 0 0 0 0-3.4Zm6.4 5.4H8.5v11.1h2.9v-5.5c0-1.5.7-2.9 2.2-2.9 1.4 0 1.5 1.3 1.5 3v5.4H18v-6.1c0-3-1.5-5.2-4.1-5.2-1.3 0-2.1.7-2.6 1.4V8.8Z"
        fill="currentColor"
      />
    </svg>
  );
}

function FlutterLogo({ className }) {
  return (
    <img
      className={className}
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg"
      alt="Flutter"
      width="48"
      height="48"
      loading="lazy"
    />
  );
}

function ReactLogo({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 256 256"
      width="54"
      height="54"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="reA" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#22D3EE" />
          <stop offset="1" stopColor="#A855F7" />
        </linearGradient>
      </defs>
      <circle cx="128" cy="128" r="18" fill="url(#reA)" />
      <g fill="none" stroke="url(#reA)" strokeWidth="10" opacity="0.95">
        <ellipse cx="128" cy="128" rx="92" ry="36" />
        <ellipse
          cx="128"
          cy="128"
          rx="92"
          ry="36"
          transform="rotate(60 128 128)"
        />
        <ellipse
          cx="128"
          cy="128"
          rx="92"
          ry="36"
          transform="rotate(120 128 128)"
        />
      </g>
    </svg>
  );
}

function StatCounter({ to, suffix = '+' }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let rafId;
    const duration = 1200;
    const startTime = performance.now();

    const animate = now => {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = 1 - (1 - progress) ** 3;
      setCount(Math.round(to * eased));
      if (progress < 1) rafId = requestAnimationFrame(animate);
    };

    rafId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(rafId);
  }, [to]);

  return (
    <>
      {count}
      {suffix}
    </>
  );
}


function Nav() {
  const scroll = id => document.getElementById(id)?.scrollIntoView({ behavior:"smooth" });
  return (
    <nav className="nav">
      <div className="nav-logo">
        <img src={abbirKhanLogo} alt="Abbir Khan logo" />
      </div>
      <div className="nav-links">
        <a href="#skills" onClick={e=>{e.preventDefault();scroll("skills")}}>Skills</a>
        <a href="#about" onClick={e=>{e.preventDefault();scroll("about")}}>About</a>
        <a href="#projects" onClick={e=>{e.preventDefault();scroll("projects")}}>Projects</a>
        <a href="#testimonials" onClick={e=>{e.preventDefault();scroll("testimonials")}}>Reviews</a>
      </div>
      <button className="nav-cta" onClick={()=>scroll("contact")}>Hire Me</button>
    </nav>
  );
}

function Hero() {
  const [portraitReady, setPortraitReady] = useState(true);

  return (
    <section className="hero">
      <div className="heroBg" aria-hidden="true" />
      <div className="heroWave" aria-hidden="true" />
      <div className="heroInner">
        <div className="heroLeft">
          <div className="heroTop">
            <div className="heroPill">
              <span className="heroPillDot" aria-hidden="true" />
              <span>FLUTTER &amp; REACT DEVELOPER</span>
            </div>

            <h1 className="heroTitle">
              I Build <span className="heroTitleGrad">Digital</span>
              <br />
              <span className="heroTitleGrad">Experiences</span>
            </h1>

            <p className="heroSubtitle">
              I create beautiful, fast and responsive mobile apps with{' '}
              <span className="heroAccent">Flutter</span> and modern websites with{' '}
              <span className="heroAccent">React</span>.
            </p>

            <div className="heroCtas">
              <a
                className="btnPrimary"
                href="#projects"
                onClick={e => {
                  e.preventDefault();
                  document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                View My Work
              </a>
              <a
                className="btnGhost"
                href="#contact"
                onClick={e => {
                  e.preventDefault();
                  document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                Contact Me
              </a>
            </div>
          </div>

          <div className="statsCard">
            <div className="stat">
              <div className="statIcon">
                <IconRocket />
              </div>
              <div className="statMeta">
                <div className="statNum"><StatCounter to={100} /></div>
                <div className="statLabel">Projects Completed</div>
              </div>
            </div>
            <div className="stat">
              <div className="statIcon">
                <IconSmile />
              </div>
              <div className="statMeta">
                <div className="statNum"><StatCounter to={40} /></div>
                <div className="statLabel">Happy Clients</div>
              </div>
            </div>
            <div className="stat">
              <div className="statIcon">
                <IconCode />
              </div>
              <div className="statMeta">
                <div className="statNum"><StatCounter to={4} /></div>
                <div className="statLabel">Years Experience</div>
              </div>
            </div>
            <div className="stat">
              <div className="statIcon">
                <IconCup />
              </div>
              <div className="statMeta">
                <div className="statNum"><StatCounter to={10} /></div>
                <div className="statLabel">Technologies</div>
              </div>
            </div>
          </div>
        </div>

        <div className="heroRight" aria-hidden="true">
          <div className="heroScene">
            <div className="heroOrbital" />
            <div className="heroPlanet" />

            <div className="heroPortraitWrap">
              {portraitReady ? (
                <img
                  className="heroPortrait"
                  src="/hero.png"
                  alt=""
                  onError={() => setPortraitReady(false)}
                />
              ) : (
                <div className="heroPortraitFallback" />
              )}
            </div>

            <div className="floatCard floatCardFlutter">
              <div className="floatCardInner">
                <FlutterLogo className="floatLogo flutterFloat" />
                <div className="floatLabel">Flutter</div>
              </div>
            </div>

            <div className="floatCard floatCardReact">
              <div className="floatCardInner">
                <ReactLogo className="floatLogo reactSpin" />
                <div className="floatLabel">React</div>
              </div>
            </div>

            <div className="codeCard">
              <div className="codeTop">
                <span className="dot dotRed" />
                <span className="dot dotYellow" />
                <span className="dot dotGreen" />
              </div>
              <pre className="codeBlock">
                <code>
                  <span className="codeKw">class</span> <span className="codeId">position</span>{' '}
                  {'{'}{'\n'}
                  {'  '}
                  <span className="codeKw">const</span> <span className="codeId">dedication</span>{' '}
                  <span className="codeOp">=</span> <span className="codeStr">'100%'</span>;{'\n'}
                  {'  '}
                  <span className="codeKw">const</span> <span className="codeId">skills</span>{' '}
                  <span className="codeOp">=</span> <span className="codeStr">['flutter', 'React']</span>;{'\n'}
                  {'  '}
                  <span className="codeKw">const</span> <span className="codeId">goal</span> <span className="codeOp">=</span>{' '}
                  <span className="codeStr">['build solution']</span>;{'\n'}
                  {'    '}
                  <span className="codeStr">'that make impact'</span>;{'\n'}
                  {'}'}{'\n'}
                </code>
              </pre>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function About() {
  const [aboutImageReady, setAboutImageReady] = useState(true);

  return (
    <section className="aboutSection" id="about">
      <div className="aboutWrap">
        <div className="aboutLeft">
          <p className="aboutEyebrow">
            <span className="aboutEyebrowLine" />
            CRAFTING DIGITAL EXPERIENCES
            <span className="aboutEyebrowSpark" />
          </p>

          <h2 className="aboutTitle">
            About <span>Me</span>
          </h2>

          <p className="aboutText">
            I&apos;m a passionate Flutter &amp; React Developer who loves building modern,
            responsive and high-performance mobile apps and websites. I turn ideas into
            digital experiences that are beautiful, functional and impactful.
          </p>

          <a className="aboutConnectBtn" href="#contact">
            <span className="aboutConnectIcon" aria-hidden="true">◌</span>
            <span>Let&apos;s Connect</span>
            <span className="aboutConnectArrow" aria-hidden="true">→</span>
          </a>

          <div className="aboutInfoRow">
            <div className="aboutInfoItem">
              <span className="aboutInfoIcon" aria-hidden="true"><IconMapPin /></span>
              <span className="aboutInfoLabel">Based In</span>
              <span className="aboutInfoValue">Pakistan</span>
            </div>
            <div className="aboutInfoItem">
              <span className="aboutInfoIcon" aria-hidden="true"><IconBolt /></span>
              <span className="aboutInfoLabel">Availability</span>
              <span className="aboutInfoValue aboutLive">Open for Work</span>
            </div>
            <div className="aboutInfoItem">
              <span className="aboutInfoIcon" aria-hidden="true"><IconClock /></span>
              <span className="aboutInfoLabel">Response</span>
              <span className="aboutInfoValue">Within 24 Hours</span>
            </div>
          </div>


        </div>

        <div className="aboutRight" aria-hidden="true">
          <div className="aboutImageCard">
            <div className="aboutImageGlow" />
            <div className="aboutImageRing aboutImageRingLeft" />
            <div className="aboutImageRing aboutImageRingRight" />
            <div className="aboutImageInner">
              {aboutImageReady ? (
                <img
                  className="aboutImage"
                  src={aboutPortrait}
                  alt=""
                  onError={() => setAboutImageReady(false)}
                />
              ) : (
                <div className="aboutImageFallback" />
              )}
            </div>
            <div className="aboutQuote">
              <span className="aboutQuoteMark">“</span>
              <p>Code is not just what I write, it&apos;s how I bring ideas to life.</p>
              <span className="aboutQuoteSign">Abbir</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Skills() {
  const [skillsVisible, setSkillsVisible] = useState(false);

  useEffect(() => {
    const section = document.getElementById('skills');
    if (!section) return undefined;

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setSkillsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -12% 0px' }
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  const skillCards = [
    {
      title: 'Flutter',
      logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg',
    },
    {
      title: 'React',
      logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg',
    },
    {
      title: 'Node.js',
      logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg',
    },
    {
      title: 'Firebase',
      logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg',
    },
    {
      title: 'TypeScript',
      logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg',
    },
    {
      title: 'Figma',
      logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg',
    },
  ];

  const technicalSkills = [
    {
      name: 'Dart',
      percent: 90,
      logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dart/dart-original.svg',
    },
    {
      name: 'JavaScript',
      percent: 85,
      logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg',
    },
    {
      name: 'HTML / CSS',
      percent: 95,
      logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg',
    },
    {
      name: 'REST API',
      percent: 88,
      logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/fastapi/fastapi-original.svg',
    },
  ];

  const tools = [
    { name: 'VS Code', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg' },
    { name: 'FastAPI', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/fastapi/fastapi-original.svg' },
    { name: 'Supabase', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/supabase/supabase-original.svg' },
    { name: 'Docker', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg' },
    { name: 'Tailwind CSS', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg' },
  ];

  return (
    <section className="skillsSection" id="skills">
      <div className="skillsWrap">
        <div className="skillsLeft">
          <p className="skillsEyebrow">
            <span className="skillsEyebrowLine" />
            WHAT I DO BEST
            <span className="skillsEyebrowSpark" />
          </p>

          <h2 className="skillsTitle">
            My <span>Skills</span>
          </h2>

          <p className="skillsText">
            I build modern and scalable digital solutions with clean code and beautiful UI,
            focusing on performance and user experience.
          </p>

          <div className="techCard">
            <h3 className="techCardTitle">Technical Skills</h3>
            <div className="techRows">
              {technicalSkills.map(item => (
                <div className="techRow" key={item.name}>
                  <div className="techRowTop">
                    <span className="techRowLabel">
                      <img src={item.logo} alt="" aria-hidden="true" />
                      {item.name}
                    </span>
                    <span className="techPercent">{item.percent}%</span>
                  </div>
                  <div className="techProgress">
                    <span style={{ width: skillsVisible ? `${item.percent}%` : '0%' }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="skillsRight">
          <div className="skillGrid">
             {skillCards.map(item => (
              <article className="skillCard" key={item.title}>
                <div className="skillIcon">
                  <img src={item.logo} alt="" aria-hidden="true" />
                </div>
                <h3>{item.title}</h3>
              </article>
            ))}
          </div>

          <div className="toolsCard">
            <h3>Other Tools &amp; Technologies</h3>
            <div className="toolsRow">
              {tools.map(tool => (
                <div className="toolItem" key={tool.name}>
                  <div className="toolIcon">
                    <img src={tool.logo} alt="" aria-hidden="true" />
                  </div>
                  <span>{tool.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Projects() {
  const tabs = ['All', 'Flutter Apps', 'Web Apps', 'UI/UX Design'];
  const [activeTab, setActiveTab] = useState('All');

  const projects = [
    {
      title: 'Vocalex Chatbot & AI Assistant',
      category: 'Flutter Apps',
      description:
        'An intelligent AI assistant app with chat, voice interaction and smart support — built with Flutter.',
      tech: ['Flutter', 'Dart', 'API Integration'],
      image: vocalexAiAssistant,
    },
    {
      title: 'Food Delivery App Design (Dark)',
      category: 'Flutter Apps',
      description:
        'A modern food delivery app UI/UX concept with user-centered flows, search, offers and subscription screens.',
      tech: ['Figma', 'UI/UX', 'Prototyping'],
      image: foodDeliveryDark,
    },
    {
      title: 'Food Delivery App Design (Light)',
      category: 'UI/UX Design',
      description:
        'A clean light-theme variation of the food delivery UI — focused on clarity, readability and smooth interactions.',
      tech: ['Figma', 'UI/UX', 'Design System'],
      image: foodDeliveryLight,
    },
    {
      title: 'Saibi Perfume Landing Page',
      category: 'Web Apps',
      description:
        'A luxury perfume website hero concept with strong typography, premium visuals and conversion-focused CTAs.',
      tech: ['React', 'Responsive UI', 'UI Design'],
      image: saibiPerfume,
    },
    {
      title: 'Vocalex Voice Companion (Landing)',
      category: 'Web Apps',
      description:
        'A product landing page concept for a voice assistant — highlighting features, benefits and onboarding CTAs.',
      tech: ['React', 'Landing Page', 'CSS'],
      image: vocalexLanding,
    },
    {
      title: 'Capital Care International Hospital',
      category: 'Web Apps',
      description:
        'A modern hospital website hero section with clear navigation, strong hierarchy and appointment-focused CTAs.',
      tech: ['React', 'Responsive UI', 'UI Design'],
      image: capitalCareHospital,
    },
  ];

  const filtered = activeTab === 'All' ? projects : projects.filter(p => p.category === activeTab);

  return (
    <section className="projectsSection" id="projects">
      <div className="projectsWrap">
        <p className="projectsEyebrow">MY WORK</p>
        <h2 className="projectsTitle">
          My <span>Projects</span>
        </h2>
        <p className="projectsText">
          Here are some of my recent projects. Each project is crafted with passion, precision
          and attention to detail.
        </p>

        <div className="projectTabs">
          {tabs.map(tab => (
            <button
              key={tab}
              className={`projectTab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        <ProjectLoop
          items={filtered}
          speed={90}
          direction="right"
          cardWidth={360}
          gap={16}
          pauseOnHover
          fadeOut
          ariaLabel="Portfolio projects"
        />
      </div>
    </section>
  );
}

const testimonialReviews = [
  {
    name: 'Malik Aizaz',
    role: 'PC Bazaar',
    avatar: malikAizazAvatar,
    text:
      'Working with Abbir was a great experience. He developed our PC Bazaar app professionally with a clean UI, smooth performance, and all the features we needed. Communication was excellent throughout the project, and he delivered everything on time. Highly recommended for Flutter app development.',
  },
  {
    name: 'James Carter',
    role: 'Product Owner',
    avatar: 'https://i.pravatar.cc/120?img=12',
    text:
      'Working with him was an absolute pleasure. He delivered a high-quality Flutter app that exceeded my expectations. Highly recommended!',
  },
  {
    name: 'Sarah Mitchell',
    role: 'CEO, TrendyWear',
    avatar: 'https://i.pravatar.cc/120?img=5',
    text:
      'He understood my requirements perfectly and built a modern, responsive website that boosted my business online presence.',
  },
];

function Testimonials() {
  const [activeDot, setActiveDot] = useState(0);
  const reviewCount = testimonialReviews.length;

  useEffect(() => {
    const id = window.setInterval(() => {
      setActiveDot(prev => (prev + 1) % reviewCount);
    }, 2200);
    return () => window.clearInterval(id);
  }, [reviewCount]);

  return (
    <section className="testimonialsSection" id="testimonials">
      <div className="testimonialsWrap">
        <p className="testimonialsEyebrow">TESTIMONIALS</p>
        <h2 className="testimonialsTitle">
          What <span>Clients Say</span>
        </h2>
        <p className="testimonialsText">
          Here&apos;s what some of my amazing clients have to say about working with me.
        </p>

        <div className="testimonialsGrid">
          {testimonialReviews.map((review, index) => (
            <article className="testimonialCard" key={review.name} style={{ animationDelay: `${index * 90}ms` }}>
              <div className="testimonialTop">
                <span className="quoteOpen">“</span>
                <span className="rating">★★★★★</span>
              </div>
              <p>{review.text}</p>
              <div className="testimonialFooter">
                <div className="reviewer">
                  <img src={review.avatar} alt={review.name} />
                  <div>
                    <h3>{review.name}</h3>
                    <span>{review.role}</span>
                  </div>
                </div>
                <span className="quoteClose">❞</span>
              </div>
            </article>
          ))}
        </div>

        <div className="testimonialDots" aria-hidden="true">
          {Array.from({ length: reviewCount }, (_, dot) => dot).map(dot => (
            <span key={dot} className={activeDot === dot ? 'active' : ''} />
          ))}
        </div>

      </div>
    </section>
  );
}

function HireMe() {
  const contactEmail = 'abbir.khan2003@gmail.com';
  const [form, setForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const socialLinks = [
    { name: 'Facebook', href: 'https://www.facebook.com/', icon: <IconFacebook /> },
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/grow_with_abbir?igsh=MTQ5cnBmeGtnaHJwcg==',
      icon: <IconInstagram />,
    },
    { name: 'LinkedIn', href: 'https://www.linkedin.com/in/abbir-khan', icon: <IconLinkedIn /> },
  ];

  const onSubmit = e => {
    e.preventDefault();

    const subject = form.subject || 'Portfolio message';
    const body = [
      `Name: ${form.name}`,
      `Email: ${form.email}`,
      '',
      'Message:',
      form.message,
    ].join('\n');

    window.location.href = `mailto:${contactEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setForm({ name: '', email: '', subject: '', message: '' });
  };

  const onChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  return (
    <section className="contactSection" id="contact">
      <div className="contactWrap">
        <div className="contactLeft">
          <p className="contactEyebrow">
            <span className="contactEyebrowSpark" aria-hidden="true" /> LET&apos;S WORK TOGETHER
          </p>

          <h2 className="contactTitle">
            Hire <span>Me</span>
          </h2>

          <p className="contactText">
            Have a project in mind? Let&apos;s bring your ideas to life with{' '}
            <span className="contactAccent">clean code</span> and stunning design.
          </p>

          <div className="contactList">
            <div className="contactListItem">
              <div className="contactListIcon" aria-hidden="true"><IconMail /></div>
              <div>
                <div className="contactListLabel">Email</div>
                <a className="contactListValue contactListLink" href="mailto:abbir.khan2003@gmail.com">
                  abbir.khan2003@gmail.com
                </a>
              </div>
              <a className="contactListGo" aria-label="Go to email" href="mailto:abbir.khan2003@gmail.com">
                <IconArrowUpRight />
              </a>
            </div>

            <div className="contactListItem">
              <div className="contactListIcon" aria-hidden="true"><IconPhone /></div>
              <div>
                <div className="contactListLabel">Phone</div>
                <a
                  className="contactListValue contactListLink"
                  href="https://wa.me/923107839332"
                  target="_blank"
                  rel="noreferrer"
                >
                  +92 3107839332
                </a>
              </div>
              <a
                className="contactListGo"
                aria-label="Go to phone"
                href="https://wa.me/923107839332"
                target="_blank"
                rel="noreferrer"
              >
                <IconArrowUpRight />
              </a>
            </div>

            <div className="contactListItem">
              <div className="contactListIcon" aria-hidden="true"><IconMapPin /></div>
              <div>
                <div className="contactListLabel">Location</div>
                <div className="contactListValue">Pakistan, Sargodha</div>
              </div>
              <button className="contactListGo" aria-label="Go to location" type="button">
                <IconArrowUpRight />
              </button>
            </div>

            <div className="contactListItem">
              <div className="contactListIcon" aria-hidden="true"><IconClock /></div>
              <div>
                <div className="contactListLabel">Availability</div>
                <div className="contactListValue">24 hours</div>
              </div>
              <button className="contactListGo" aria-label="Go to availability" type="button">
                <IconArrowUpRight />
              </button>
            </div>
          </div>

          <div className="contactBottomCard">
            <div className="contactBottomText">
              Let&apos;s turn your ideas into <br />
              powerful digital solutions.
            </div>
            <div className="contactBottomPlane" aria-hidden="true">
              <IconSend />
            </div>
          </div>
        </div>

        <div className="contactRight">
          <div className="contactFormCard">
            <div className="contactFormHeader">
              <div className="contactFormIcon" aria-hidden="true">
                <IconSend />
              </div>
              <div>
                <div className="contactFormTitle">Send Me a Message</div>
                <div className="contactFormSub">Fill out the form and I&apos;ll get back to you soon.</div>
              </div>
            </div>

            <form onSubmit={onSubmit} className="contactForm">
              <div className="contactFormRow">
                <label className="contactField">
                  <span className="contactFieldLabel">Your Name</span>
                  <input
                    name="name"
                    value={form.name}
                    onChange={onChange}
                    placeholder="Your Name"
                    required
                  />
                </label>
                <label className="contactField">
                  <span className="contactFieldLabel">Your Email</span>
                  <input
                    name="email"
                    value={form.email}
                    onChange={onChange}
                    placeholder="Your Email"
                    type="email"
                    required
                  />
                </label>
              </div>

              <label className="contactField">
                <span className="contactFieldLabel">Subject</span>
                <input
                  name="subject"
                  value={form.subject}
                  onChange={onChange}
                  placeholder="Subject"
                  required
                />
              </label>

              <label className="contactField">
                <span className="contactFieldLabel">Your Message</span>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={onChange}
                  placeholder="Your Message"
                  required
                />
              </label>

              <button type="submit" className="contactSubmit">
                Send Message <IconSend />
              </button>
            </form>

            <div className="contactSocial">
              <div className="contactSocialLeft">
                <div className="contactSocialTitle">Prefer to talk?</div>
                <div className="contactSocialSub">Let&apos;s connect and discuss your project.</div>
              </div>
              <div className="contactSocialIcons">
                {socialLinks.map(item => (
                  <a
                    key={item.name}
                    href={item.href}
                    aria-label={item.name}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {item.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Footer() {
  const year = new Date().getFullYear();
  const scroll = id => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  const footerLinks = [
    { label: 'Skills', id: 'skills' },
    { label: 'About', id: 'about' },
    { label: 'Projects', id: 'projects' },
    { label: 'Reviews', id: 'testimonials' },
    { label: 'Contact', id: 'contact' },
  ];
  const socialLinks = [
    { name: 'Facebook', href: 'https://www.facebook.com/', icon: <IconFacebook /> },
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/grow_with_abbir?igsh=MTQ5cnBmeGtnaHJwcg==',
      icon: <IconInstagram />,
    },
    { name: 'LinkedIn', href: 'https://www.linkedin.com/in/abbir-khan', icon: <IconLinkedIn /> },
  ];

  return (
    <footer className="siteFooter">
      <div className="footerWrap">
        <div className="footerBrand">
          <img src={abbirKhanLogo} alt="Abbir Khan logo" />
          <div>
            <div className="footerName">Abbir Khan</div>
            <div className="footerContact footerBrandContact">
              <a href="mailto:abbir.khan2003@gmail.com">abbir.khan2003@gmail.com</a>
              <a href="tel:+923107839332">+92 310 7839332</a>
              <span>Pakistan, Sargodha</span>
            </div>
          </div>
        </div>

        <nav className="footerMiniLinks" aria-label="Footer navigation">
          {footerLinks.map(link => (
            <a
              key={link.id}
              href={`#${link.id}`}
              onClick={event => {
                event.preventDefault();
                scroll(link.id);
              }}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="footerColumn footerSocialBlock">
          <h2>Follow</h2>
          <div className="footerSocial">
            {socialLinks.map(item => (
              <a key={item.name} href={item.href} aria-label={item.name} target="_blank" rel="noreferrer">
                {item.icon}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="footerBottom">
        <span>&copy; {year} Abbir Khan. All rights reserved.</span>
      </div>
    </footer>
  );
}

function App() {
  useEffect(() => {
    const targets = document.querySelectorAll(
      [
        '.statsCard',
        '.floatCard',
        '.codeCard',
        '.aboutFeatureCard',
        '.aboutInfoItem',
        '.aboutImageCard',
        '.techCard',
        '.skillCard',
        '.toolsCard',
        '.toolIcon',
        '.projectCard',
        '.testimonialCard',
        '.contactListItem',
        '.contactBottomCard',
        '.contactFormCard',
        '.contactSocialIcons a',
        '.footerSocial a',
      ].join(', ')
    );

    const edgeThreshold = 56;
    const cleanups = [];

    targets.forEach(target => {
      target.classList.add('edgeGlow');

      const onPointerMove = event => {
        const rect = target.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        const nearestEdge = Math.min(x, y, rect.width - x, rect.height - y);
        const nearRatio = Math.max(0, 1 - nearestEdge / edgeThreshold);

        target.style.setProperty('--edge-x', `${x}px`);
        target.style.setProperty('--edge-y', `${y}px`);
        target.style.setProperty('--edge-opacity', nearRatio.toFixed(3));
      };

      const onPointerLeave = () => {
        target.style.setProperty('--edge-opacity', '0');
      };

      target.addEventListener('pointermove', onPointerMove);
      target.addEventListener('pointerleave', onPointerLeave);

      cleanups.push(() => {
        target.removeEventListener('pointermove', onPointerMove);
        target.removeEventListener('pointerleave', onPointerLeave);
        target.classList.remove('edgeGlow');
        target.style.removeProperty('--edge-x');
        target.style.removeProperty('--edge-y');
        target.style.removeProperty('--edge-opacity');
      });
    });

    return () => {
      cleanups.forEach(cleanup => cleanup());
    };
  }, []);

  useEffect(() => {
    const revealTargets = document.querySelectorAll(
      [
        '.heroLeft',
        '.heroRight',
        '.statsCard',
        '.floatCard',
        '.codeCard',
        '.aboutLeft',
        '.aboutRight',
        '.aboutInfoItem',
        '.aboutFeatureCard',
        '.aboutImageCard',
        '.skillsLeft',
        '.skillsRight',
        '.techCard',
        '.skillCard',
        '.toolsCard',
        '.toolItem',
        '.projectsEyebrow',
        '.projectsTitle',
        '.projectsText',
        '.projectTabs',
        '.projectCard',
        '.testimonialsEyebrow',
        '.testimonialsTitle',
        '.testimonialsText',
        '.testimonialCard',
        '.testimonialDots',
        '.contactLeft',
        '.contactRight',
        '.contactListItem',
        '.contactBottomCard',
        '.siteFooter',
      ].join(', ')
    );

    revealTargets.forEach((target, index) => {
      target.classList.add('scrollReveal');
      target.style.setProperty('--reveal-delay', `${Math.min(index * 20, 180)}ms`);
    });

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('isVisible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -5% 0px' }
    );

    revealTargets.forEach(target => observer.observe(target));

    return () => {
      observer.disconnect();
      revealTargets.forEach(target => {
        target.classList.remove('scrollReveal', 'isVisible');
        target.style.removeProperty('--reveal-delay');
      });
    };
  }, []);

  return (
    <div className="appRoot">
      <SplashCursor
        RAINBOW_MODE={false}
        COLOR="#a855f7"
        BACK_COLOR={{ r: 0.14, g: 0.03, b: 0.24 }}
      />
      <div className="globalBg" aria-hidden="true" />
      <Nav />
      <Hero />
      <Skills />
      <About />
      <Projects />
      <Testimonials />
      <HireMe />
      <Footer />
    </div>
  );
}

export default App;
